export default __webpack_public_path__ + "static/media/7edf40b8579faa30.d450f725b72c4d9e705bb6ab151f61cf.svg";